<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Student's Documents</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button class="btn add-btn" @click="showAddDocumentPopup()">
            <i class="fa fa-plus"></i>Add Document
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Student Info -->
    <div class="card">
      <div class="card-body pb-1 pt-3">
        <div class="row">
          <div class="col-sm-3">
            <label class="mr-2"><b>Student ID: </b></label>{{ studentID }}
          </div>
          <div class="col-sm-3">
            <label class="mr-2"><b>Name:</b></label>
            {{ studentName }}
          </div>
          <div class="col-sm-3">
            <label class="mr-2"><b>Email:</b></label>
            {{ studentEmail }}
          </div>
          <div class="col-sm-3">
            <label class="mr-2"><b>School:</b></label>
            {{ schoolName }}
          </div>
        </div>
      </div>
    </div>
    <!-- /Student Info -->

    <!-- Table Result -->
    <document-table
      :uploaderUserType="tokenObj.UserType"
      :userId="$route.params.id"
      :key="counter"
    ></document-table>
    <!-- /Table Result -->

    <!-- Add Document Modal -->
    <div class="modal custom-modal fade" id="addDocument" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <add-document
          @refreshData="refreshData"
          isFromUserDocument="true"
          :sourceUserType="userTypeStudent"
          :sourceUserId="$route.params.id"
          :sourceSchoolId="schoolId"
          :key="counter"
        ></add-document>
      </div>
    </div>
    <!-- /Add Document Modal -->

    <!-- Button Back -->
    <div class="text-center mt-4">
      <router-link
        class="btn btn-primary"
        :to="{
          name:
            tokenObj.UserType == userTypeMainAdmin
              ? 'mainAdminStudentList'
              : 'schoolAdminStudentList',
        }"
      >
        <i class="fa fa-reply mr-2"></i>Back to Students
      </router-link>
    </div>
    <!-- /Button Back -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
import DocumentTable from "../../Shared/DocumentTable.vue";
import AddDocument from "../../Shared/DocumentAdd.vue";
import $ from "jquery";
export default {
  components: {
    DocumentTable,
    AddDocument,
  },
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeStudent: config.USERTYPE_STUDENT,
      studentID: "",
      studentName: "",
      studentEmail: "",
      schoolName: "",
      schoolId: "",
      counter: 0,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  methods: {
    showAddDocumentPopup() {
      $("#addDocument").modal("show");
    },
    refreshData() {
      $("#addDocument").modal("hide");
      this.counter++;
    },
    getStudentDetail() {
      let param = {
        Token: this.tokenObj.Token,
        Id: this.$route.params.id,
      };
      this.$store.state.isLoading = true;
      API.student
        .getStudentDetail(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            let data = response.data.data;
            this.studentID = data.UserName;
            this.studentName = data.Name;
            this.studentEmail =
              data.Emails && data.Emails.length ? data.Emails[0].Email : null;
            this.schoolName = data.SchoolName;
            this.schoolId = data.SchoolId;
            this.counter++;
          } else {
            this.$store.state.isLoading = false;
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
  },
  created() {
    this.getStudentDetail();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/StudentDocument.vue